import { render } from "./CreateInternalUser.vue?vue&type=template&id=6ad51842&scoped=true&ts=true"
import script from "./CreateInternalUser.vue?vue&type=script&lang=ts"
export * from "./CreateInternalUser.vue?vue&type=script&lang=ts"

import "./CreateInternalUser.vue?vue&type=style&index=0&id=6ad51842&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ad51842"]])

export default __exports__